import folderStore from "owa-folders";
import { ATTACHMENTS_SEARCH_FOLDER_NAME } from "owa-folders-constants";

export default function isAttachmentsSearchFolder(folderId: string): boolean {
    return folderStore().folderTable.get(folderId)?.displayName === ATTACHMENTS_SEARCH_FOLDER_NAME;
}
